import PropTypes from "prop-types";
import Box from "ui-box";
import { withTheme } from "evergreen-ui";
import { boxProps, boxPropTypes } from "components/materials/utils";
import { getProps, compose, withMemo } from "./utils";

const TableHead = compose(
  ({ children, ...props }) => {
    return (
      <Box is="thead" {...boxProps(props)}>
        {children}
      </Box>
    );
  },
  [withMemo, withTheme]
);

export const propTypes = {
  ...boxPropTypes,
  children: PropTypes.node,
};

TableHead.propTypes = propTypes;

// TODO: remove dot notation
TableHead.getProps = (props) => getProps(propTypes, props);

export default TableHead;
